import { HelmetProvider } from "react-helmet-async"
import { RenderRoutes } from "./routes"

export const App: React.FunctionComponent = () => {
	return (
		<HelmetProvider>
			<RenderRoutes />
		</HelmetProvider>
	)
}
